(ns ycweb.app.website.myaccount.addresses.common
  (:require
   [rum.core :as rum]
   [ycweb.components.transitions :as t]
   [ycweb.components.common :as cmn]
   [ycweb.util.core :as u]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.forms :as input-forms]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.headings :as headings]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.components.toaster :as toaster]))


(rum/defcs addressedit < rum/reactive (cmn/local nil ::node-atom) [local-atom app-atom]
  (let [state-atom (cmn/action-cursor app-atom)
        address-atom (rum/cursor-in state-atom [:address])
        country-atom (rum/cursor-in address-atom [:address/country :ent/uuid])
        node-atom (::node-atom local-atom)

        address (rum/react address-atom)

        countries (cmn/curact state-atom [:countries])
        country-id
        (if (string? (rum/react country-atom))
          (u/uuid (rum/react country-atom))
          (rum/react country-atom))

        country (get countries country-id)
        local-country-code (cmn/curact app-atom [:config :sa-country-code])]

    [:div.dashboard
     (headings/heading
       (if (:add? address) "Add Address" "Edit Address")
       {:type :h2 :size :medium})
     [:form.form.u-max-width-480
      {:ref (fn [node] (reset! node-atom node))}
      (forms/input "First name:" "e.g. Jane"
        (rum/cursor address-atom :address/firstname)
        {:type :user
         :required? true
         :id :firstname
         :name :firstname})

      (forms/input "Last name:" "e.g. Smith"
        (rum/cursor address-atom :address/lastname)
        {:type :user
         :id :lastname
         :name :lastname})

      (forms/input "Company: (optional)" ""
        (rum/cursor address-atom :address/company)
        {:type :text
         :id :company
         :name :company})

      (forms/input "VAT number:" ""
        (rum/cursor address-atom :address/vatnumber)
        {:type :text
         :id :vatnumber
         :name :vatnumber})


      ;;; https://betterprogramming.pub/the-best-practice-with-google-place-autocomplete-api-on-react-939211e8b4ce
      ;; or https://github.com/Tintef/react-google-places-autocomplete
      ;; https://tintef.github.io/react-google-places-autocomplete/docs/
      ;;todo - google address search - we'll do when we do checkout
      #_[:div.js-google-address-container
         [:div.form-field
          [:div.field-highlight
           [:label.form-label.js-form-label {:for "autocomplete"} "Search for your address:"]
           [:div.yc-text-input-wrapper
            [:input#autocomplete.js-google-autocomplete.text-input.text-input--address.js-text-input.pac-target-input {:type "text" :data-container "js-google-address-container" :data-countrycode "ZA" :placeholder "Enter your address" :autocomplete "off"}]
            [:i.text-input-icon]]
           [:div.form-hint-wrapper
            [:span.form-hint.js-form-hint "Powered by Google"]]]]
         [:input.js-google-selected-address
          {:type "hidden"
           :name "google_checkaddress[google_selected_address]" :value "0"}]
         [:input.js-googlecheck-address {:type "hidden" :name "google_checkaddress[address]" :value ""}]
         [:input.js-googlecheck-sublocality_level_2 {:type "hidden" :name "google_checkaddress[suburb]" :value ""}]
         [:input.js-googlecheck-locality {:type "hidden" :name "google_checkaddress[city]" :value ""}]
         [:input.js-googlecheck-postal_code {:type "hidden" :name "google_checkaddress[postalcode]" :value ""}]]
      #_[:script
         {:src
          "https://maps.googleapis.com/maps/api/js?key=AIzaSyAOCQrlmxLRaX5Kw_JY3-5fiVtGGPeLKss&libraries=places&callback=initAutocomplete"
          :async true
          :defer true}]

      (forms/textarea "Address:"
        (rum/cursor address-atom :address/address)
        {:id :address
         :name :address
         :required? true
         :rows "3"
         :cols "30"})

      (forms/input "Suburb:" ""
        (rum/cursor address-atom :address/suburb)
        {:type :text
         :id :suburb
         :name :suburb})

      (forms/input "City:" ""
        (rum/cursor address-atom :address/city)
        {:type :text
         :required? true
         :id :city
         :name :city})

      (forms/input "Postal code:" ""
        (rum/cursor address-atom :address/postalcode)
        {:type :text
         :required? true
         :id :postalcode
         :name :postalcode})

      (forms/select "Country:" country-atom
        (into
          []
          (->>
            countries
            (vals)
            (sort-by :ent/display-name)
            (map
              (fn [c]
                {:text (u/capitalize-words (:ent/display-name c))
                 :value (:ent/uuid c)}))))
        {:type :string})

      (when (not (= (:country/code country) local-country-code))
        [:div.u-margin-top-20
         (feedback/feedback :warning "We don't ship outside of South Africa"
           "You're welcome to set this address as your billing address, but we do not ship outside of South Africa.")])

      [:div.form-field
       (forms/checkbox "Make this my default billing address" (rum/cursor-in address-atom [:address/setbilling])
         {:id :setbilling
          :name :setbilling})]

      [:div.form-field
       (forms/checkbox "Make this my default delivery address" (rum/cursor-in address-atom [:address/setdelivery])
         {:id :setdelivery
          :name :setdelivery
          :disabled (not (= (:country/code country) local-country-code))})]

      (forms/input "Telephone:" "e.g. 021 000 0000"
        (rum/cursor address-atom :address/tel)
        {:type :phone
         :id :tel
         :name :tel})

      (forms/input "Cellphone:" "e.g. 083 000 0000"
        (rum/cursor address-atom :address/cell)
        {:type :phone
         :id :cell
         :name :cell})

      [:div.form-label.form-label--set "Address Type:"]

      [:div.form-field
       (input-forms/radio "Residential Address" "Residential" (rum/cursor address-atom :address/type))]
      [:div.form-field
       (input-forms/radio "Business Address" "Business" (rum/cursor address-atom :address/type))]

      [:div.form-control
       (buttons/button-web "Save settings"
         {:on-click
          (forms/form-validate node-atom #(grid/dispatch-action app-atom :web.myaccount.address/save {:address address}))
          :type :button
          :style :primary
          :size :default})]]
     (toaster/loading-overlay app-atom :web.myaccount/address-edit)]))
